import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { BillServiceSchema } from "../types"

export const useGetSingleBillService = (bill_id: string) => {
  const api = useApi()
  const [data, setData] = useState<BillServiceSchema | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  const refetch = () => {
    setLoading(true)

    api.get(`probill/get-bill-service-detail/${bill_id}`)
    .then((res: SuccessFetch<{ payload: BillServiceSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    api.get(`probill/get-bill-service-detail/${bill_id}`)
    .then((res: SuccessFetch<{ payload: BillServiceSchema }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false))

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}